import React from 'react';

import { ArrowForward } from '@lyearn/icons';
import { cn } from '@lyearn/style';

import { Avatar } from '../../Avatar';
import Dot from '../../Dot';
import Stack from '../../Stack';
import { InfoPillProps } from './types';
import {
  DEFAULT_INFO_PILL_APPEARANCE,
  DEFAULT_INFO_PILL_SIZE,
  getInfoPillIconColor,
  INFO_PILL_AVATAR_SIZE,
  INFO_PILL_DOT_BACKGROUND,
  INFO_PILL_DOT_SIZE,
  INFO_PILL_ICON_SIZE,
} from './utils';

export const renderInfoPillIcon = (props: InfoPillProps) => {
  switch (props.type) {
    case 'avatar': {
      const size = INFO_PILL_AVATAR_SIZE[props.size || DEFAULT_INFO_PILL_SIZE];

      return <Avatar alt={props.alt} size={size} src={props.src} />;
    }
    case 'icon': {
      const { Icon } = props;
      const iconColor = getInfoPillIconColor(props.appearance);
      const size = INFO_PILL_ICON_SIZE[props.size || DEFAULT_INFO_PILL_SIZE];

      return <Icon className={cn('shrink-0', iconColor)} height={size} width={size} />;
    }
    case 'color': {
      const background = INFO_PILL_DOT_BACKGROUND[props.appearance || DEFAULT_INFO_PILL_APPEARANCE];
      const size = INFO_PILL_DOT_SIZE[props.size || DEFAULT_INFO_PILL_SIZE];

      return <Dot background={background} size={size} />;
    }
    default: {
      return undefined;
    }
  }
};

export const renderInfoPillLabel = (props: InfoPillProps) => {
  switch (props.type) {
    case 'range': {
      const iconColor = getInfoPillIconColor(props.appearance);
      return (
        <Stack alignItems="center">
          {props.label}
          <ArrowForward className={cn('mx-4 w-14 h-14 ', iconColor)} />
          {props.endLabel}
        </Stack>
      );
    }
    default: {
      return props.label;
    }
  }
};
